import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from "../../box/src";
import { Dotdotdot } from "../../dotdotdot/src";
import { CATEGORIES, FontAwesomeIcon } from "../../font-awesome-icon/src";
import { Image } from "../../image/src";
import { FONT_BRIGHTNESS_MAPPING, primaryShadow, useTheme, } from "../../theme/src";
export const Flag = (_a) => {
    var { bg, borderColor, color, iconColor = 'primary', iconName, imageUrl, maxWidth = '200px', text } = _a, otherProps = __rest(_a, ["bg", "borderColor", "color", "iconColor", "iconName", "imageUrl", "maxWidth", "text"]);
    const theme = useTheme();
    const { frameBackgroundColor, frameFontBrightness } = theme.themeVariables;
    return (_jsxs(Wrapper, Object.assign({ "$borderColor": borderColor, "$displayIconOrImage": Boolean(iconName) || Boolean(imageUrl), bg: bg || frameBackgroundColor, "data-testid": "flag", maxWidth: maxWidth }, otherProps, { children: [iconName && (_jsx(Box, { mr: 2, children: _jsx(FontAwesomeIcon, { color: iconColor, height: "16px", iconName: iconName, iconType: CATEGORIES.SOLID }) })), imageUrl && (_jsx(Box, { alignItems: "flex-start", flexGrow: 0, flexShrink: 0, mr: 2, children: _jsx(ImageWrapper, { children: _jsx(Image, { alt: "", src: imageUrl }) }) })), _jsx(Dotdotdot, { clamp: 1, children: _jsx(Title, { color: color || FONT_BRIGHTNESS_MAPPING.asphalt[frameFontBrightness], children: text }) })] })));
};
const Wrapper = styled(Box).attrs(({ $displayIconOrImage }) => ({
    alignItems: 'center',
    display: 'inline-flex',
    height: 32,
    pl: $displayIconOrImage ? 3 : 4,
    pr: 4,
})) `
  ${primaryShadow}
  border-radius: 5px;
  border-left: ${({ $borderColor, theme }) => {
    var _a;
    return $borderColor
        ? `6px solid ${((_a = theme.colors) === null || _a === void 0 ? void 0 : _a[$borderColor]) || $borderColor}`
        : undefined;
}};
  z-index: 10;
`;
const ImageWrapper = styled(Box).attrs(() => ({
    height: 22,
    width: 22,
})) `
  border-radius: 50%;
  overflow: hidden;
`;
const Title = styled(Box).attrs(() => ({
    display: 'block',
    flexGrow: 1,
    font: 'body-semibold-asphalt',
})) `
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
//# sourceMappingURL=Flag.js.map